import React from "react";
import LinkListItemWithIcon from "../LinkListItemWithIcon/LinkListItemWithIcon";
import { List } from "@mui/material";
import checkMediaObjectsImage from "../../assets/icon/icon_dokumente_prüfen.svg";
import beaSearchIcon from "../../assets/icon/bea_search.svg";
import beaAttachmentFilterIcon from "../../assets/icon/filter_listpx.svg";
import beaListIcon from "../../assets/icon/Tools_beA.svg";
import beaStatusIcon from "../../assets/icon/beA_status.svg";
import hintsIcon from "../../assets/icon/icon_hints.svg";
import { userHasOneOfTheseRoles } from "../../services/backofficeUserService";
import { BackofficeUser, Roles } from "../../types/BackofficeUser";
import ScannerOutlinedIcon from "@mui/icons-material/ScannerOutlined";
import { usePendingTasks } from "../../hooks/usePendingTasks";

type MailProps = {
  currentUser: BackofficeUser;
};

const Mail = ({ currentUser }: MailProps) => {
  const pendingTasks = usePendingTasks();

  return (
    <List>
      <LinkListItemWithIcon
        title={"Label- und Kennerübersicht"}
        description={"Einsehen aller momentan verfügbaren Dokumentenlabels und Aktionskenner"}
        to={"/services/tools/labelübersicht"}
        imageIcon={hintsIcon}
      />
      <LinkListItemWithIcon
        title={"Dokumente prüfen"}
        description={"Dokumente prüfen, freigeben und zuordnen"}
        to={"/services/tools/dokumente-pruefen"}
        imageIcon={checkMediaObjectsImage}
        badgeContent={pendingTasks?.scanCheckRequiredMediaObjectsCount}
      />
      <LinkListItemWithIcon
        title={"Anlagen"}
        description={"Sichten und Zusammenfügen von Schriftsätzen und Anhängen"}
        to={"/services/tools/anlagen"}
        imageIcon={beaListIcon}
        badgeContent={pendingTasks?.manualAttachmentMergeCount}
      />
      <LinkListItemWithIcon
        title={"beA-Status"}
        description={"Retry-Liste und Status des beA-Systems"}
        to={"/services/tools/bea/status"}
        imageIcon={beaStatusIcon}
        badgeContent={pendingTasks?.activeBeaRetriesCount}
      />
      <LinkListItemWithIcon
        title={"beA-Adressen"}
        description={"Empfänger in beA suchen"}
        to={"/services/tools/bea/suche"}
        imageIcon={beaSearchIcon}
      />
      <LinkListItemWithIcon
        title={"beA-Anhangsfilter"}
        description={"Nicht benötigte Anhänge aussortieren"}
        to={"/services/tools/bea/anhangs-filter"}
        imageIcon={beaAttachmentFilterIcon}
      />
      {userHasOneOfTheseRoles(currentUser, [Roles.admin, Roles.developer]) &&
        import.meta.env.VITE_DEPLOYMENT !== "production" && (
          <LinkListItemWithIcon
            title={"Dokument für Testing scannen"}
            description={"Datei durch Upload in den Scanprozess überführen"}
            to={"/services/tools/dokument-scannen"}
            MuiIcon={ScannerOutlinedIcon}
          />
        )}
    </List>
  );
};

export default Mail;
